import { Injectable } from '@angular/core';
import { Product } from '@core/models/piramide/Product';
import {
  CoolerCpu,
  CoolerFan,
  Cpu,
  Disco,
  Fuente,
  Gabinete,
  Memoria,
  Monitor,
  Mother,
  PlacaVideo,
} from './model';

@Injectable({
  providedIn: 'root',
})
export class ProductFactory {
  crearPorSubcategoria(producto: Product): Product {
    switch (producto.id_subcategoria) {
      case 48:
      case 27:
        return new Cpu(producto);
      case 49:
      case 26:
        return new Mother(producto);
      case 36:
        return new CoolerCpu(producto);
      case 15:
      case 47:
        return new Memoria(producto);
      case 6:
      case 62:
      case 116:
        return new PlacaVideo(producto);
      case 81:
      case 19:
        return new Disco(producto);
      case 34:
        return new Fuente(producto);
      case 7:
        return new Gabinete(producto);
      case 5:
        return new Monitor(producto);
      case 35:
        return new CoolerFan(producto);
      default:
        return new Product(producto);
      // case 2:
      //     case 38:
      //     case 39:
      //     case 8:
      //     case 52:
    }
  }
}
